import { Pipe } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'hasRequired',
  standalone: true
})
export class HasRequiredPipe {
  transform(control: AbstractControl): boolean {
    if (!control || !control.validator) return false;

    const validatorFn = control.validator({} as AbstractControl);
    return validatorFn?.['required'] === true;
  }
}
